var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _vm._v("\n    " + _vm._s(_vm.$t("SummaryReport.Menu.BasicInfo")) + "\n  ")
    ]),
    _vm._v(" "),
    _vm.basicInfo
      ? _c(
          "div",
          [
            _c("text-label-row", {
              attrs: { title: "OrganisationName", id: "organisationname" },
              model: {
                value: _vm.basicInfo.organisationName,
                callback: function($$v) {
                  _vm.$set(_vm.basicInfo, "organisationName", $$v)
                },
                expression: "basicInfo.organisationName"
              }
            }),
            _vm._v(" "),
            _c("text-label-row", {
              attrs: { title: "AidTargetNumber", id: "purpose" },
              model: {
                value: _vm.basicInfo.aidTargetIdentifier,
                callback: function($$v) {
                  _vm.$set(_vm.basicInfo, "aidTargetIdentifier", $$v)
                },
                expression: "basicInfo.aidTargetIdentifier"
              }
            }),
            _vm._v(" "),
            _c("text-label-row", {
              attrs: { title: "Purpose", id: "purpose" },
              model: {
                value: _vm.basicInfo.purpose,
                callback: function($$v) {
                  _vm.$set(_vm.basicInfo, "purpose", $$v)
                },
                expression: "basicInfo.purpose"
              }
            }),
            _vm._v(" "),
            _c("text-label-row", {
              attrs: {
                title: "SummaryReport.BasicInfo.GrantedAmount",
                id: "purpose",
                formatNumber: true,
                sign: "€"
              },
              model: {
                value: _vm.basicInfo.grantedAmount.toString(),
                callback: function($$v) {
                  _vm.$set(_vm.basicInfo.grantedAmount, "toString()", $$v)
                },
                expression: "basicInfo.grantedAmount.toString()"
              }
            }),
            _vm._v(" "),
            _c("text-label-row", {
              attrs: {
                title: "SummaryReport.BasicInfo.ReportYear",
                id: "purpose"
              },
              model: {
                value: _vm.basicInfo.year.toString(),
                callback: function($$v) {
                  _vm.$set(_vm.basicInfo.year, "toString()", $$v)
                },
                expression: "basicInfo.year.toString()"
              }
            }),
            _vm._v(" "),
            _c("location-control", {
              attrs: {
                location: _vm.basicInfo.location,
                showChannels: false,
                summaryReport: true,
                allowRegionOption: _vm.allowRegionLocationOption
              }
            }),
            _vm._v(" "),
            _c("radio-button-row", {
              key: _vm.radioButtonValueChanged,
              attrs: {
                title: "SummaryReport.BasicInfo.PersonnelResources",
                required: true
              },
              model: {
                value: _vm.basicInfo.personnelResourcesAsPlanned,
                callback: function($$v) {
                  _vm.$set(_vm.basicInfo, "personnelResourcesAsPlanned", $$v)
                },
                expression: "basicInfo.personnelResourcesAsPlanned"
              }
            }),
            _vm._v(" "),
            _vm.basicInfo.personnelResourcesAsPlanned == false
              ? _c("text-area-row", {
                  attrs: {
                    title:
                      "SummaryReport.BasicInfo.PersonnelResources_Description",
                    id: "personnelresourcesdescription",
                    required: true,
                    maxLength: 1000,
                    rows: 7
                  },
                  model: {
                    value: _vm.basicInfo.personnelResourcesDescription,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.basicInfo,
                        "personnelResourcesDescription",
                        $$v
                      )
                    },
                    expression: "basicInfo.personnelResourcesDescription"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "h3",
              [
                _c("plain-text-control", {
                  attrs: {
                    title: "SummaryReport.BasicInfo.AdditionalInformation.Title"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("text-area-row", {
              attrs: {
                title: "SummaryReport.BasicInfo.AdditionalInformation.Name",
                id: "contactperson_name",
                required: true,
                maxLength: 100,
                rows: 1,
                rules: { name: true },
                noResize: true,
                hideCharsLeft: true
              },
              model: {
                value: _vm.basicInfo.contactPerson_Name,
                callback: function($$v) {
                  _vm.$set(_vm.basicInfo, "contactPerson_Name", $$v)
                },
                expression: "basicInfo.contactPerson_Name"
              }
            }),
            _vm._v(" "),
            _c("text-area-row", {
              attrs: {
                title: "SummaryReport.BasicInfo.AdditionalInformation.Email",
                id: "contactperson_email",
                required: true,
                maxLength: 100,
                rows: 1,
                rules: { email: true },
                noResize: true,
                hideCharsLeft: true
              },
              model: {
                value: _vm.basicInfo.contactPerson_Email,
                callback: function($$v) {
                  _vm.$set(_vm.basicInfo, "contactPerson_Email", $$v)
                },
                expression: "basicInfo.contactPerson_Email"
              }
            }),
            _vm._v(" "),
            _c("text-area-row", {
              attrs: {
                title: "SummaryReport.BasicInfo.AdditionalInformation.Phone",
                id: "contactperson_phone",
                required: true,
                maxLength: 16,
                rows: 1,
                rules: { phone: true },
                noResize: true,
                hideCharsLeft: true
              },
              model: {
                value: _vm.basicInfo.contactPerson_Phone,
                callback: function($$v) {
                  _vm.$set(_vm.basicInfo, "contactPerson_Phone", $$v)
                },
                expression: "basicInfo.contactPerson_Phone"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }